import { render } from "./CertificatePrint.vue?vue&type=template&id=2c500685"
import script from "./CertificatePrint.vue?vue&type=script&lang=js"
export * from "./CertificatePrint.vue?vue&type=script&lang=js"

import "./CertificatePrint.vue?vue&type=style&index=0&id=2c500685&lang=scss"

import exportComponent from "/var/www/certificates-staging.paginasingeniosas.com/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__